import { getField, updateField } from 'vuex-map-fields';
import moment from 'moment';
import apiAxios from '../../services/apiAxios';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,

    tarjetaMarcaDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_TARJETA_MARCA' (state, tarjetaMarcaId) {
        state.id = tarjetaMarcaId;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_TARJETA_MARCA' (state, tarjetaMarca) {
        state.nombre = tarjetaMarca.nombre.toUpperCase().trim();
        state.inactivo = tarjetaMarca.inactivo;
        state.rowVersion = tarjetaMarca.rowVersion;
    },

    'INICIALIZAR_TARJETA_MARCA_DATOS' (state) {
        state.tarjetaMarcaDatos = [];
    },
    'SET_TARJETA_MARCA_DATOS' (state, params) {
        state.tarjetaMarcaDatos = params.tarjetaMarcaDatos;
    }
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, tarjetaMarcaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETA_MARCA', tarjetaMarcaId);

            if (tarjetaMarcaId) {
                if (tarjetaMarcaId != 0) {
                    apiAxios.get('tarjetasmarcas/' + tarjetaMarcaId + '/abm' ) 
                    .then(res => {
                        commit('SET_TARJETA_MARCA', res.data);

                        resolve();
                    })
                    .catch(error =>  {
                        reject(error);
                    });
                } else {
                    resolve();    
                }
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            
            let tarjetaMarca= {
                nombre: state.nombre.toUpperCase().trim(),
                inactivo: state.inactivo,
            }
            let url = 'tarjetasmarcas';
            if (state.id != 0) {
                url += "/" + state.id;
                tarjetaMarca.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, tarjetaMarca)
                .then(() => {
                    resolve();
                })
                .catch( error => {
                    var appError = false
                    var errorMessage = ''
                    if (error.response.status == 500) {
                        if (error.response.headers['application-error']) {
                            errorMessage = error.response.data
                        }
                    }
                    if (!appError) {
                        errorMessage = error.response.data
                    }          
                    var res = {
                        updated: false,
                        errorMessage: errorMessage
                    }    
                    reject(res)
                })
        })
    },
    getTarjetaMarcaDatos ( { commit }, tarjetaMarcaId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_TARJETA_MARCA_DATOS');

            if (tarjetaMarcaId != 0) {
                apiAxios.get('tarjetasmarcas/' + tarjetaMarcaId ) 
                .then(res => {
                    let tarjetaMarcaDatos = [
                        { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                        { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                        { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                    ];
                    
                    let params = {
                        tarjetaMarcaDatos 
                    }
                    commit('SET_TARJETA_MARCA_DATOS', params);

                    resolve();
                })
                .catch(error => {
                    reject(error);
                })
            } else {
                resolve();
            }
            
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}